import type { DataForCreateDatabase } from '@/entities/database';
import request from '@/shared/api/request';

export const getDataForCreateDatabase = (): Promise<DataForCreateDatabase> =>
  request({
    url: '/databases/data_for_create/',
  });
